export const FAVOURITE_BUTTON_CLASSNAME = 'favourite-button';
export const FAVOURITE_TRANSITION_CLASSNAME = 'favourite-button__icon-wrapper--transition';
export const FAVOURITE_ICON_TRANISITION_DURATION_IN_MS = 300;
